import { useState, useEffect } from 'react';
import axios from 'axios';
import { User, Coffee, Pause, Play } from 'lucide-react';

const API_BASE = import.meta.env.VITE_API_URL || '/api';

export default function AgentStatusManager({ agentId }) {
  const [status, setStatus] = useState('online');
  const [breakReason, setBreakReason] = useState('');
  const [loading, setLoading] = useState(false);

  const updateStatus = async (newStatus, reason = null) => {
    setLoading(true);
    try {
      const token = localStorage.getItem('accessToken');
      await axios.post(
        `${API_BASE}/dialer/agents/${agentId}/status`,
        { status: newStatus, break_reason: reason },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setStatus(newStatus);
    } catch (error) {
      console.error('Error updating status:', error);
      alert('Failed to update status');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white rounded-lg shadow p-4 space-y-3">
      <h3 className="font-semibold">Agent Status</h3>
      <div className="flex gap-2">
        <button
          onClick={() => updateStatus('online')}
          disabled={loading || status === 'online'}
          className={`flex-1 px-3 py-2 rounded flex items-center justify-center gap-2 ${
            status === 'online' ? 'bg-green-600 text-white' : 'bg-gray-200 hover:bg-gray-300'
          }`}
        >
          <User className="w-4 h-4" />
          Online
        </button>
        <button
          onClick={() => updateStatus('break')}
          disabled={loading || status === 'break'}
          className={`flex-1 px-3 py-2 rounded flex items-center justify-center gap-2 ${
            status === 'break' ? 'bg-yellow-600 text-white' : 'bg-gray-200 hover:bg-gray-300'
          }`}
        >
          <Coffee className="w-4 h-4" />
          Break
        </button>
        <button
          onClick={() => updateStatus('pause')}
          disabled={loading || status === 'pause'}
          className={`flex-1 px-3 py-2 rounded flex items-center justify-center gap-2 ${
            status === 'pause' ? 'bg-orange-600 text-white' : 'bg-gray-200 hover:bg-gray-300'
          }`}
        >
          <Pause className="w-4 h-4" />
          Pause
        </button>
      </div>
      {(status === 'break' || status === 'pause') && (
        <input
          type="text"
          placeholder="Break reason (optional)"
          value={breakReason}
          onChange={(e) => setBreakReason(e.target.value)}
          className="w-full border rounded px-3 py-2"
        />
      )}
    </div>
  );
}


